import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';

@Component({
    selector: 'fi-items-list-actions',
    template: `
        <button
            mat-flat-button
            class="fi-forum-list-action-button"
            [disabled]="disabled()"
            color="primary"
            [matMenuTriggerFor]="itemsListActionMenu"
        >
            {{ 'common.with_selected' | fiAppText }}
            <span class="fas fa-chevron-down"></span>
        </button>

        <mat-menu #itemsListActionMenu class="fi-rounded-menu">
            @for (action of actions(); track $index) {
                @if (!action.condition || action.condition()) {
                    <button
                        mat-menu-item
                        (click)="action.onClick()"
                        [disabled]="action.disabled && action.disabled()"
                        [attr.aria-label]="action.title"
                    >
                        <span>{{ action.title }}</span>
                    </button>
                }
            }
        </mat-menu>
    `,
    styleUrls: ['./fi-items-list-actions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-items-list-actions' },
    standalone: false,
})
export class FiItemsListActionsComponent {
    public actions = input<IItemsListAction2[]>([]);
    public disabled = input<boolean>(false);
}
